import { ChartOptions } from 'chart.js';

export const LINE_CHART_OPTIONS: ChartOptions<'line'> = {
  maintainAspectRatio: false,
  responsive: true,
  layout: {
    padding: {
      bottom: 5, // Add padding to the bottom of the chart
    },
  },
  elements: {
    line: {
      tension: 0.3, // Smooth curve
      borderColor: '#0e74bc',
      borderWidth: 1,
      borderDash: [],
      borderDashOffset: 0.0,
    },
    point: {
      borderWidth: 1,
      backgroundColor: 'white',
      borderColor: 'rgba(14, 116, 188, 0.8)',
      // hoverBackgroundColor: 'rgba(14, 116, 188, 1)',
      hoverBorderWidth: 2,
      hoverRadius: 4,
      radius: 2,
    },
  },
  plugins: {
    tooltip: {
      enabled: true,
      mode: 'index',
      intersect: false,
      titleColor: '#333',
      backgroundColor: '#f5f5f5',
      bodyColor: '#666',
      bodySpacing: 4,
      padding: 12,
    },
    datalabels: {
      color: 'black',
      font: {
        size: 10,
      },
      borderColor: 'white',
      borderRadius: 5,
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
      padding: 2,
      anchor: 'end',
      clamp: true,
      align: (context) => {
        if (
          Array.isArray(context.dataset?.data) &&
          typeof context.dataset.data[context.dataIndex] === 'number'
        ) {
          const value = context.dataset.data[context.dataIndex] as number;

          // Get the maximum value on the y-axis scale
          const maxScaleValue = context.chart.scales.y?.max;

          if (typeof maxScaleValue === 'number' && value > maxScaleValue / 2) {
            return 'bottom'; // Align to bottom if the value is greater than half of the max scale value
          } else {
            return 'top'; // Align to top otherwise
          }
        }

        return 'top'; // Default alignment
      },
      offset: 3,
      display: 'auto',
    },
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      grid: {
        drawBorder: false,
        color: 'rgba(29,140,248,0.0)',
        borderColor: 'transparent', // Replaces zeroLineColor
      },
      // NOTE: disabled: as specifying a min causes issue with the zero values, point cut by lower half
      // min: 0, // Replaces suggestedMin
      ticks: {
        padding: 10,
        color: '#9a9a9a',
      },
    },
    x: {
      grid: {
        drawBorder: false,
        color: 'rgba(29,140,248,0.1)',
        borderColor: 'transparent', // Replaces zeroLineColor
      },
      ticks: {
        padding: 5,
        color: '#9a9a9a',
      },
    },
  },
};

export const LINE_CHART_OPTIONS_NO_COUNT_LABELS: ChartOptions<'line'> = {
  ...LINE_CHART_OPTIONS,
  plugins: {
    ...LINE_CHART_OPTIONS.plugins,
    datalabels: {
      display: false,
    },
  },
};
